module.exports = __webpack_public_path__ + "static/media/foul-play-feature-banner-md@2x.c4e5f117.jpg";